// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import loginPage from 'myWorld/base/login';

myw.localisation.init(['myw.client']);

$(() => {
    const loginInfo = JSON.parse(unescape($('body').data('myw-login-info')));

    myw.app = loginPage; //for debugging purposes
    loginPage.init(loginInfo);
});
